import React, { useState } from "react";
import {
  ChevronRightIcon,
} from "@heroicons/react/solid";
import { useSelector } from "react-redux";

export default function DeliveryModal() {
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addGoodsinout = Array.isArray(Permissions) ? Permissions.find((o) => o.codename === "add_goodsinout"):[];
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <div className="mt-8 mb-8 float-right">
        <>
        {!addGoodsinout ===undefined ||  addGoodsinout?.codename ===
          "add_goodsinout" ? (
          <button
            type="button"
            class="text-blue-900  bg-white hover:bg-gray-100 border border-blue-700 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
            onClick={() => setShowModal(true)}
          >
            <svg
              className="pr-2"
              width="21"
              height="17"
              viewBox="0 0 21 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 8.5H21M10.5 0.5V16.5"
                stroke="#1F78B4"
                stroke-width="2"
              />
            </svg>
            Add Delivery
          </button>
          ):null}
          {showModal ? (
            <>
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
                  {/*content*/}
                  <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between   rounded-t">
                      <h3 className="text-xl pl-3 pt-3 font-semibold">
                        Make a Delivery{" "}
                      </h3>
                      <button
                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => setShowModal(false)}
                      >
                        <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                          ×
                        </span>
                      </button>
                    </div>
                    <h3 className="text-sm pl-3 flex font-semibold">
                      <p className="text-blue-900 flex">
                        Ongoing{" "}
                        <ChevronRightIcon className="w-[18px] h-[18px] mt-[3px]" />{" "}
                      </p>
                      Make Delivery{" "}
                    </h3>
                    {/*body*/}
                    <div className="relative p-6 flex-auto">
                      <div className="flex justify-center mb-8">
                        <div className="justify-center ">
                          <div class=" inline-flex">
                            <div className="bg-blue-200 text-white py-1 px-3 w-fit rounded-full active:font-bold">
                              1
                            </div>
                            <div className="inline-flex text-gray-500 mt-1 ml-2 font-bold active:font-bold">
                              General Details{" "}
                             
                            </div>
                          </div>
                          <div class=" inline-flex w-24 mb-1 ml-4 mr-4 bg-gray-300 rounded-full h-0.5 "></div>
                          <div class="inline-flex ml-2">
                            <div className="bg-red-300 text-white py-1 px-3 w-fit rounded-full active:font-bold">
                              2
                            </div>
                            <div className="text-gray-500 mt-1 ml-2 active:font-bold">
                              Delivery Details
                            </div>
                          </div>
                          <div class=" inline-flex w-24 mb-1 ml-4 mr-1 bg-gray-300 rounded-full h-0.5 "></div>
                          <div class="inline-flex ml-2">
                            <div className="bg-green-500 text-white py-1 px-3 w-fit rounded-full active:font-bold">
                              3
                            </div>
                            <div className="text-gray-500 mt-1 ml-2 active:font-bold">
                              Review Location
                            </div>
                          </div>
                        </div>
                      </div>
                      <form>
                        <div class="relative z-0 w-full mb-6 group">
                          <input
                            type="text"
                            name="Delivery_name"
                            class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                            placeholder=" "
                            required
                          />
                          <label
                            for="Delivery_name"
                            class="peer-focus:font-medium absolute text-sm text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-900 peer-focus:dark:text-blue-900 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                          >
                            Delivery Name
                          </label>
                        </div>
                        <div class="relative z-0 w-full mb-6 group">
                          <select
                            id="items"
                            class=" border mt-8 border-gray-200 text-gray-400 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-3"
                            placeholder=" "
                            required
                          >
                            <option selected>Select Items/Assemblies</option>
                            <option value="US">XYZ-Items</option>
                            <option value="CA">XYZ-Items</option>
                            <option value="FR">XYZ-Items</option>
                            <option value="DE">XYZ-Items</option>
                          </select>
                        </div>
                        <div class="relative z-0 w-full mb-6 group">
                          <input
                            type="number"
                            name="qty"
                            class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                            placeholder=" "
                            required
                          />
                          <label
                            for="qty"
                            class="peer-focus:font-medium absolute text-sm text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-900 peer-focus:dark:text-blue-900 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                          >
                            Quantity
                          </label>
                        </div>
                        <div class="relative z-0 w-full mb-6 group">
                          <input
                            type="date"
                            name="date"
                            class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                            placeholder=" "
                            required
                          />
                          <label
                            for="date"
                            class="peer-focus:font-medium absolute text-sm text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-900 peer-focus:dark:text-blue-900 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                          >
                            Dispatch Date
                          </label>
                        </div>
                        <div class="relative z-0 w-full mb-6 group">
                          <select
                            id="customers"
                            class=" border mt-8 border-gray-200 text-gray-400 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-3"
                            placeholder=" "
                            required
                          >
                            <option selected>Choose a Customers</option>
                            <option value="US">United States</option>
                            <option value="CA">Canada</option>
                            <option value="FR">France</option>
                            <option value="DE">Germany</option>
                          </select>
                        </div>
                      </form>
                    </div>
                    {/*footer*/}
                    <div className="flex p-6 border-t border-solid border-slate-200 rounded-b">
                      <div className="float-left">
                        <button
                          className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                          type="button"
                          onClick={() => setShowModal(false)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="float-right ml-auto">
                        <button
                          className="bg-green-500  text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                          type="button"
                          onClick={() => setShowModal(false)}
                        >
                          Next Step
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null}
        </>
      </div>
    </div>
  );
}
